import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

import Button from 'settings/page-elements/Button';

const ClientsListDownload = ({ isFetching, errorMessage, clientsListCSV, salonId }) => {
  const { t } = useTranslation();

  return (
    <div className="clients hidden">
      <div className="download-status-message">
        {isFetching && (
          <div>
            <span>{t('businessReports.downloadableReports.fetchingClientListCSV')}</span>
          </div>
        )}
        {errorMessage && (
          <div>
            <span className="alert warning">{t('businessReports.downloadableReports.errorFetchingClientListCSV', { errorMessage })}</span>
          </div>
        )}
      </div>
      <div className="transactions">
        <div className="list-view row">
          <div className="col-lg-12 log">
            {t('businessReports.downloadableReports.clientList')}
            <Button buttonName={t('businessReports.downloadableReports.downloadClientListButton')} onClickButton={() => clientsListCSV(salonId)} className="btn-sm pull-right" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientsListDownload;
